import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const frsSection = document.querySelectorAll('.comparison-table-v2-section');

    frsSection.forEach(section => {
        const frsCardSlider = section.querySelector('.cts-plan-slider');

        new Swiper(frsCardSlider, {
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                prevEl: section.querySelector('.cts-button-prev'),
                nextEl: section.querySelector('.cts-button-next'),
            },
            pagination: {
                el: section.querySelector('.cts-pagination'),
                clickable: true,
            },
            breakpoints: {
                767: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            },
        });
    });
});
